import React, { createContext, useCallback, useContext, useEffect, useMemo, useState } from 'react'
import { usePreference, setPreference } from '@fs/zion-preferences'
import { dismissGettingStartedCardPref } from '../services/usePreloadPreferences'

const GettingStartedContext = createContext()

/**
 *
 * @returns {{
 * showGettingStartedState: 'card'|'list-item'|undefined
 * setDoNotShowCardAgain: ()=>void
 * }}
 */

export const useGettingStarted = () => {
  const context = useContext(GettingStartedContext)
  if (!context) throw new Error('You need to use the GettingStartedProvider to use useGettingStarted')
  return context
}

/**
 *
 * @param {{children: import('react').ReactNode}} props
 * @returns
 */

export default function GettingStartedProvider({ children }) {
  const [showGettingStartedState, setShowGettingStartedState] = useState()
  const showGettingStartedCard = usePreference(dismissGettingStartedCardPref)

  useEffect(() => {
    if (showGettingStartedCard === '' || showGettingStartedCard === false) {
      setShowGettingStartedState('card')
    } else if (showGettingStartedCard === true) {
      setShowGettingStartedState('list-item')
    }
  }, [showGettingStartedCard])

  const setDoNotShowCardAgain = useCallback(() => {
    setPreference(dismissGettingStartedCardPref, true)
    setShowGettingStartedState('list-item')
  }, [])

  const value = useMemo(
    () => ({
      /** show gettingStartedCard or gettingStartedListItem */
      showGettingStartedState,
      setDoNotShowCardAgain,
    }),
    [setDoNotShowCardAgain, showGettingStartedState]
  )
  return <GettingStartedContext.Provider value={value}>{children}</GettingStartedContext.Provider>
}
